<template>
  <input type="text" id="rut" class="form-control" placeholder="RUT" v-model="formatedRut" maxlength="12" required />
</template>
<script>
export default {
  name: 'InputRut',
  data () {
    return {
      rut: ''
    }
  },
  props: ['value'],
  computed: {
    formatedRut: {
      get () {
        return this.formatRut(this.rut)
      },
      set (modifiedValue) {
        this.rut = modifiedValue
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    formatRut (number) {
      var rutNumbersArray = number.split('')
      rutNumbersArray.forEach(function (number, index) {
        if (index === 2 || index === 6) {
          if (number !== '.') {
            rutNumbersArray.splice(index, 0, '.')
          }
        }
      })

      if (!rutNumbersArray.includes('-') && rutNumbersArray.length === 10) {
        rutNumbersArray.push('-')
      }

      return rutNumbersArray.join('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputRut.vue